import { apiClient, type PartnerExEntity } from '@/libs/api'
import { type InHouseRequestQuery } from '@/libs/api/types'

export type FetchInHouseQuery = {
  tenantKey: string
  query: InHouseRequestQuery
}

export type FetchInHouseResponse = PartnerExEntity

export const fetchInHouse = async (
  { tenantKey, query }: FetchInHouseQuery,
  signal?: AbortSignal
): Promise<FetchInHouseResponse> => {
  const { data } = await apiClient._tenant(tenantKey).partners.in_house.$get({
    query,
    config: {
      signal
    }
  })
  return data
}
